import Signup from './pages/Signup/Signup';
import ActivateAccount from './pages/Signup/ActivateAccount/ActivateAccount';
import CreatePin from './pages/Signup/PinGeneration/CreatePin';
import ConfirmPin from './pages/Signup/PinGeneration/ConfirmPin';
import Verification from './pages/Signup/Verification/Verification';
import LinkBank from './pages/Signup/LinkBank/LinkBank';
import NotFound from './pages/NotFound/NotFound';
import WentWrong from './pages/WentWrong/WentWrong';
import Account from './pages/Account/Account';
import Transaction from './pages/Account/Transaction/Transaction';
import Profile from './pages/Account/Profile/Profile';
import Payment from './pages/Account/Payment/Payment';
import Documents from './pages/Account/Documents/Documents';
import Settings from './pages/Account/Settings/Settings';
import Helpcenter from './pages/Account/Helpcenter/Helpcenter';
import Login from './pages/Login/Login';
import EnterPin from './pages/Login/EnterPin';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ActivateForgotPassword from './pages/ForgotPassword/ActivateForgotPassword';
import EnterEmail from './pages/ForgotPassword/EnterEmail';
import NewPassword from './pages/ForgotPassword/NewPassword';
import AllSet from './pages/ForgotPassword/AllSet';
import ForgotPIN from './pages/ForgotPIN/ForgotPIN';
import RequestReset from './pages/ForgotPIN/RequestReset';
import CreateNewPIN from './pages/ForgotPIN/CreateNewPIN';
import ConfirmNewPIN from './pages/ForgotPIN/ConfirmNewPIN';
import MarketPlace from './pages/MarketPlace/MarketPlace';
import MarketplaceInitial from './pages/MarketPlace/MarketplaceInitial';
import MarketplaceSecondary from './pages/MarketPlace/MarketplaceSecondary';
import Legal from './pages/Legal/Legal';
import Portfolio from './pages/Portfolio/Portfolio';
// import IOSingle from './pages/PropertyListing/IOSingle';
// import IOMulti from './pages/PropertyListing/IOMulti';
// import SMVacation from './pages/PropertyListing/SMVacation';
import SMDetails from './pages/PropertyListing/SMDetails';
import PropertyDetails from './pages/PropertyListing/PropertyDetails';
import AssetDetails from './pages/Portfolio/AssetDetails';
import Favorites from './pages/MarketPlace/Favorites';
import ReLogin from './pages/ReLogin/ReLogin';
import ReLoginOutlet from './pages/ReLogin/ReLoginOutlet';
import ReEnterPin from './pages/ReLogin/ReEnterPin';
import { SignupAuth } from './pages/Signup/SignupAuth';
import AffiliateProgram from './pages/AffiliateProgram/AffiliateProgram';

export const routePaths = [
  {
    mainRoute: { path: '/', component: MarketPlace, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/login', component: Login, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up', component: Signup, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-upAuth', component: SignupAuth, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up/activation', component: ActivateAccount, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up/createpin', component: CreatePin, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/reactive-account/createpin', component: CreatePin, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/reactive-account/confirmpin', component: ConfirmPin, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up/confirmpin', component: ConfirmPin, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up/verification', component: Verification, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/sign-up/linkbank', component: LinkBank, exact: true, isAuth: true },
  },
  {
    mainRoute: { path: '/not-found', component: NotFound, exact: false, isAuth: false },
  },
  {
    mainRoute: { path: '/went-wrong', component: WentWrong, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/marketplace/initial', component: MarketplaceInitial, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/marketplace/secondary', component: MarketplaceSecondary, exact: true, isAuth: true },
  },
  {
    mainRoute: { path: '/marketplace/favorites', component: Favorites, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/', component: Account, exact: true, isAuth: false },
    subRoute: [
      { path: 'account', component: Profile, exact: true, isAuth: true },
      { path: 'account/transactions', component: Transaction, exact: true, isAuth: true },
      { path: 'account/payment', component: Payment, exact: true, isAuth: true },
      { path: 'account/settings', component: Settings, exact: true, isAuth: true },
      { path: 'account/help-center', component: Helpcenter, exact: true, isAuth: true },
      { path: 'account/documents', component: Documents, exact: true, isAuth: true },
      { path: 'account/legal', component: Legal, exact: true, isAuth: true },
      { path: 'account/affiliate-program', component: AffiliateProgram, exact: true, isAuth: true },
      { path: 'account/:slug', component: Profile, exact: true, isAuth: true },
    ],
  },
  {
    mainRoute: { path: '/legal', component: Legal, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/login', component: Login, exact: true },
  },
  {
    mainRoute: { path: '/login/enterpin', component: EnterPin, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-password', component: ForgotPassword, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-password/activation', component: ActivateForgotPassword, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-password/enter-email', component: EnterEmail, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-password/new-password', component: NewPassword, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-password/allset', component: AllSet, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-pin', component: ForgotPIN, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-pin/request-reset', component: RequestReset, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-pin/create-new-pin', component: CreateNewPIN, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/forgot-pin/confirm-new-pin', component: ConfirmNewPIN, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/marketplace', component: MarketPlace, exact: true, isAuth: false },
  },
  {
    mainRoute: { path: '/portfolio', component: Portfolio, exact: true, isAuth: true },
  },
  {
    mainRoute: { path: '/portfolio/assets/:propertyId', component: AssetDetails, exact: true, isAuth: false },
  },
  {
    mainRoute: {
      path: '/property/:propertyType/:propertyId',
      component: PropertyDetails,
      exact: true,
      isAuth: false,
    },
  },
  {
    mainRoute: {
      path: '/property/secondary/:propertyId/details',
      component: SMDetails,
      exact: true,
      isAuth: true,
    },
  },
  // {
  //   mainRoute: { path: '/property/initial-single', component: IOSingle, exact: true, isAuth: false },
  // },
  // {
  //   mainRoute: { path: '/property/initial-multi', component: IOMulti, exact: true, isAuth: false },
  // },
  // {
  //   mainRoute: { path: '/property/secondary-vacation', component: SMVacation, exact: true, isAuth: false },
  // },
  // {
  // mainRoute: { path: '/property/secondary-details', component: SMDetails, exact: true, isAuth: false },
  // },
  {
    mainRoute: { path: '/', component: ReLoginOutlet, exact: true, isAuth: false },
    subRoute: [
      { path: 're-login', component: ReLogin, exact: true, isAuth: false },
      { path: 're-login/enterpin', component: ReEnterPin, exact: true, isAuth: false },
    ],
  },
];
